
<div class="flex-container">
  <button matIconButton (click)="openClientInfoDialog()">
    <mat-icon class="material-icons-outlined">info</mat-icon>
  </button>
  @if(clientContracts())
  {
    <button matIconButton (click)="openClientContractDialog()">
      <mat-icon class="material-icons-outlined">inventory_2</mat-icon>
    </button>
  }
</div>

<ng-template #clientInfoDialog>
  <app-edit-client [client]="client()" [integrations]="integrations()" />
</ng-template>

<ng-template #clientContractDialog >
  <app-client-contracts
    [client]="client()"
    [integrations]="integrations()"
    [destinationEndpoints]="destinationEndpoints()"
    [integrationIdentifiers]="clientIdentifiers()"
    [(clientContracts)]="clientContracts"
    [selectedIntegrationId]="integration()?.integrationId" />

</ng-template>

<ng-template #clientContractDeleteConfirmationDialog>
  <h2 matDialogTitle>Add Contract Term Date to Client Contract</h2>
  <mat-dialog-content>
    <p>Integration deleted is the last integration mapped for Client Contract. Please set Date for ContractTermDate for Client Contract.</p>
    <div class="example-wrapper">
      <app-lt-datetimepicker
          style="width: 210px"
          placeholder="Enter a date and time"
          format="MM/dd/yyyy hh:mm:ss a"
          [(value)]="clientContractTermDate">
      </app-lt-datetimepicker>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    @if (clientContractTermDate !== null) {
      <button matButton matDialogClose (click)="updateClientContractTermDate()">Update</button>
    }
    <button matButton matDialogClose>Close</button>
  </mat-dialog-actions>
</ng-template>
